module.exports = {"maximeter_analysis":"Anàlisi de maxímetre","date_range":"Rang de dates","all_devices":"Tots els dispositius","graph":"Gràfic","table":"Taula","max_historical":"Històric Maxímetre"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/Maximeter.json
// module id = 592
// module chunks = 1